module.exports = __webpack_public_path__ + "static/media/icon_light_bulb.e3464bb1.svg";